var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.75 7.125C4.30228 7.125 4.75 7.57272 4.75 8.125V18.1232C4.75101 18.3554 4.8437 18.5779 5.00792 18.7421C5.17212 18.9063 5.39452 18.999 5.6267 19H18.3733C18.6055 18.999 18.8279 18.9063 18.9921 18.7421C19.1563 18.5779 19.249 18.3555 19.25 18.1233V8.125C19.25 7.57272 19.6977 7.125 20.25 7.125C20.8023 7.125 21.25 7.57272 21.25 8.125V18.125L21.25 18.128C21.2477 18.889 20.9444 19.6182 20.4063 20.1563C19.8682 20.6944 19.139 20.9977 18.378 21L18.375 21H5.625L5.62201 21C4.86101 20.9977 4.13182 20.6944 3.59371 20.1563C3.05559 19.6182 2.75228 18.889 2.75 18.128L2.75 18.125V8.125C2.75 7.57272 3.19772 7.125 3.75 7.125Z",
  fill: "#003F76"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 11,
  width: 6,
  height: 2,
  rx: 1,
  fill: "#003F76"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.6538 4H3.34615C2.60269 4 2 4.6268 2 5.4V6.6C2 7.3732 2.60269 8 3.34615 8H20.6538C21.3973 8 22 7.3732 22 6.6V5.4C22 4.6268 21.3973 4 20.6538 4Z",
  stroke: "#003F76",
  strokeWidth: 2,
  strokeLinejoin: "round"
})));
export default __webpack_public_path__ + "static/media/archive.8a8dd4a0.svg";
export { SvgComponent as ReactComponent };